import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ISuggestMeetingRequestByTokenPayload } from '@app-store/slices/meetingRequests/suggestByToken'

interface TaskAction extends Action {
    payload: ISuggestMeetingRequestByTokenPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.suggestByToken

function* createMeetingRequestByTokenSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/meeting/meeting-requests/suggest/${payload.token}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError()
    }
}

function* createMeetingRequestByTokenSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createMeetingRequestByTokenSagaTask)
}

export default createMeetingRequestByTokenSaga
